import React, { useEffect, useState } from 'react';
import '../../../assets/styles/KYC.css';
import {
    DataGrid, GridToolbar, GridToolbarContainer,
    GridToolbarExport,
} from '@material-ui/data-grid';
import { useDistributorContext } from '../../../services/contexts/DistributorContext';
import { configs } from '../../../assets/Config';
import { Link } from 'react-router-dom';
import { useLogin } from '../../../services/contexts/AdminLoginContext';
import LeftBarPage from '../../includes/dashboard/LeftBarPage';
import TopBarPage from '../../includes/dashboard/TopBarPage';
import { useHistory } from 'react-router-dom';

export default function DistributorReviewLeadsPage() {

    const { error, getFormLeads, formLeads, setKycRequesterUserDetail, setKycRequesterUserComplete, setpanDoc,
        setaddressDoc,
        setbankDoc,
        setdematDoc } = useDistributorContext()

    const { allowedFunc, setCurrModule } = useLogin()

    const history = useHistory()

    useEffect(() => {
        if (allowedFunc.includes(configs.functionList['distributor_management:load_distributor_details'])) {
            setCurrModule(configs.modules.distFormLead)
        } else {
            return history.goBack()
        }
    }, [])

    // declare table rows
    const [columns, setColumns] = useState([
        { field: "id", headerName: "ID", minWidth: 100, flex: 0.5, hide: true, filterable: false },
        { field: "name", headerName: "Name", minWidth: 100, flex: 0.4, cellClassName: "break-text" },
        {
            field: "email", headerName: "E-mail", minWidth: 150, flex: 0.4, cellClassName: "break-text f-12", renderCell: (params) => {
                // if (allowedFunc.includes(configs.functionList['distributor_management:load_distributor_details'])) {
                //     return <Link to={`/distributorProfile/${params.row.id}`} onClick={() => {
                //         setKycRequesterUserDetail(params.row)
                //     }}>{params.row.email}</Link>
                // } else {
                return params.row.email
                // }
            }, valueGetter: (value) => value.row.email
        },
        {
            field: "mobile", headerName: "Mobile No.", minWidth: 100, flex: 0.3, cellClassName: "break-text", renderCell: (params) => {
                return params.row.mobile
            }, valueGetter: (value) => value.row.mobile
        },
        { field: "message", headerName: "Message", minWidth: 400, flex: 0.5, cellClassName: "break-text" },
        { field: "timestamp", headerName: "Timestamp", minWidth: 100, flex: 0.5, cellClassName: "break-text" },
    ])

    // get list of kyc requesters
    useEffect(() => {
        (async () => {
            try {
                await getFormLeads();
            } catch (error) {

            }
        })();
    }, [])

    // react data table export option
    function CustomToolbar() {
        return (
            <GridToolbarContainer>
                <GridToolbarExport csvOptions={{ allColumns: true }}/>
            </GridToolbarContainer>
        );
    }

    // admin kyc requesters basic details ui code
    return (
        <>
            <TopBarPage />
            <div style={{ display: "flex" }}>
                <LeftBarPage />
                <div id='custStatContainer' className="smbo-container">
                    <div style={{ width: "100%" }}>
                        <div className="row mx-md-4 mx-2 my-2 p-0">
                            <p className="text-custom-grey h3 mt-2 ml-3">Form Leads</p>
                        </div>
                        <div className="kyc-table">
                            {formLeads ? <DataGrid
                                rows={formLeads}
                                columns={columns}
                                resizable={true}
                                autoPageSize
                                rowHeight={40}
                                headerHeight={30}
                                pagination
                                components={{
                                    Toolbar: GridToolbar,
                                }}
                            />
                                : <div className="loader"></div>}
                        </div>


                    </div>
                </div>
            </div>
        </>
    )
}